import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useState } from "react";
import ProfileLayout from "./layout";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { patchRequest } from "services/api";
import Swal from "sweetalert2";

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        old_password: "",
        new_password: "",
        confirm_new_password: ""
    });

    const updateProfile = async (data) => {
        try {
            const result = await patchRequest('/change-password', data);
            return { success: true, data: result };
        } catch (err) {
            const errorResponse = {
                code: err.code || null,
                message: err.errors || 'An error occurred',
            };
            return { success: false, errorResponse };
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }

    const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();
    const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
        updateProfile,
        async () => {
            const result = await Swal.fire({
                title: "Success!",
                text: "You successfully changed the password!", // Updated text
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok!",
                cancelButtonText: "No, cancel!",
                allowOutsideClick: false, // Prevents closing the modal by clicking outside
                customClass: {
                    confirmButton: 'btn btn-success me-2',
                    cancelButton: 'btn btn-secondary'
                },
                buttonsStyling: false,
            });

            if (result.isConfirmed) {
                window.location.reload();
            }
        },
        handleError
    );


    const handleBeforeSubmit = (e) => {
        e.preventDefault();
        if (formData.new_password !== formData.confirm_new_password) {
            handleError(true, "Passwords do not match");
            return;
        }
        handleSubmit(formData, e);
    }

    return (
        <ProfileLayout>
            {/* <form onSubmit={(e) => handleBeforeSubmit(e)}>
                <div className="card-body">
                    <h2 className="card-title mt-4 mb-4">General</h2>
                    <p className="card-subtitle">You can set a permanent password if you don't want to use temporary login codes.</p>
                    <div className="mb-4">
                        <div className="row g-2">
                            <div className="col-auto">
                                <input type="password" className="form-control gotra-form-control w-auto mb-3" name="old_password" value={formData.old_password} onChange={handleChange} placeholder="Enter your old password" />
                                <input type="password" className="form-control gotra-form-control w-auto mb-3" name="new_password" value={formData.new_password} onChange={handleChange} placeholder="Enter your password" />
                                <input type="password" className="form-control gotra-form-control w-auto mt-3" name="confirm_new_password" value={formData.confirm_new_password} onChange={handleChange} placeholder="Confirm your password" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer bg-transparent mt-auto">
                    <div className="btn-list justify-content-end">
                        <button type="submit" className="btn btn-primary">Save</button>
                    </div>
                </div>
            </form> */}
            {/* welcome */}
            <div className="card-body">
                Welcome
            </div>
        </ProfileLayout>
    );
};

export default ChangePassword;